<template>
  <el-table v-loading="loading" :data="tableData" border style="width: 100%" show-summary :summary-method="getSummaries">
    <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
    <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" />
    <!-- <el-table-column prop="orderSales" label="订单金额" align="left" /> -->
    <!-- <el-table-column prop="assignAmount" label="已分配金额" align="left" /> -->
    <el-table-column prop="usedScale" label="分配金额比例" align="right" header-align="left" />
    <el-table-column prop="createBy" label="分配人" align="left" />
    <el-table-column prop="createTime" label="分配日期" align="left" />
  </el-table>
</template>
<script type="es6">
import { selectDesensitizationAssignDetailByContractId } from '@/API';
// import { MathAdd, numDiv } from '@/libs/util';
export default {
  data () {
    return {
      tableData: [],
      loading: false
    };
  },
  props: {
    contractId: {
      type: [String, Number],
      required: true
    }
  },
  components: {},
  computed: {
    // allAssignAmount () {
    //   let cont = 0;
    //   this.tableData.forEach((item) => {
    //     cont = MathAdd(cont, item.assignAmount);
    //   });
    //   return cont;
    // }
  },
  methods: {
    initData () {
      this.loading = true;
      selectDesensitizationAssignDetailByContractId(this.contractId).then((res) => {
        let json = res.data;
        this.loading = false;
        if (json.status === '200') {
          this.tableData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        // if (column.label === '订单金额' && this.tableData.length) {
        //   sums[index] = this.tableData[0].contractSum;
        //   return;
        // }
        // if (column.label === '已分配金额') {
        //   sums[index] = this.allAssignAmount;
        //   return;
        // }
        if (column.label === '分配金额比例' && this.tableData.length) {
          // let pre = (numDiv(this.allAssignAmount * 100, this.tableData[0].contractSum)).toFixed(2);
          // sums[index] = `${pre}%`;
          sums[index] = this.allAssignAmount();
        }
      });
      return sums;
    },
    toPercent (point) {
      var str = Number(point).toFixed(2);
      str += '%';
      return str;
    },
    allAssignAmount () {
      let all = 0;
      this.tableData.forEach((item) => {
        all += Number(item.usedScale.replace('%', ''));
        // debugger;
      });
      return this.toPercent(all);
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
